import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { NotificationPreferences } from '@indutrust/notification-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';
import type { Observable } from 'rxjs';

/**
 * API client for the current-user notification preferences singleton —
 * `GET` / `PATCH` `/api/v1/notification_preferences`.
 *
 * Frontend-owned contract until the backend Postman collection adds the
 * resource; MSW mirrors the same paths for demo and unit tests.
 */
@Service()
export class NotificationPreferencesApiClient extends BaseApiClient<NotificationPreferences> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<NotificationPreferences> = {};

  /** Loads the authenticated user's preferences singleton. */
  get(): Observable<NotificationPreferences> {
    return this.http.get<NotificationPreferences>(this.url);
  }

  /**
   * Partially updates the preferences singleton (no `:id` segment —
   * the resource is scoped to the current user server-side).
   *
   * Named `updateCurrent` to avoid colliding with {@link BaseApiClient.update}.
   */
  updateCurrent(
    partial: Partial<NotificationPreferences>
  ): Observable<NotificationPreferences> {
    return this.http.patch<NotificationPreferences>(this.url, partial);
  }

  get url(): string {
    return `${this.envService.getApiUrl()}/notification_preferences`;
  }
}
